export default __webpack_public_path__ + "9a7e0e0d643ede5f083c45d0486deac8.png";